// removed by extract-text-webpack-plugin
module.exports = {"tagSelect":"antd-pro-tagSelect","expanded":"antd-pro-expanded","trigger":"antd-pro-trigger","hasExpandTag":"antd-pro-hasExpandTag"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/TagSelect/index.less
// module id = 378
// module chunks = 0 1